var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_313_899)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1.75V19.25V20.5H11.25H3.75H1.25C0.546875 20.5 0 19.9531 0 19.25C0 18.5859 0.546875 18 1.25 18H2.5V4.13281C2.5 3.27344 3.08594 2.53125 3.90625 2.29688L10.9375 0.539062C11.2891 0.460938 11.6797 0.539062 11.9922 0.773438C12.3047 1.00781 12.5 1.39844 12.5 1.75ZM10 10.5C10 9.83594 9.57031 9.25 9.0625 9.25C8.51562 9.25 8.125 9.83594 8.125 10.5C8.125 11.2031 8.51562 11.75 9.0625 11.75C9.57031 11.75 10 11.2031 10 10.5ZM13.75 5.5V3H17.5C18.8672 3 20 4.13281 20 5.5V18H21.25C21.9141 18 22.5 18.5859 22.5 19.25C22.5 19.9531 21.9141 20.5 21.25 20.5H18.75C18.0469 20.5 17.5 19.9531 17.5 19.25V5.5H13.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_313_899",
    x: 0,
    y: 0.460938,
    width: 22.5,
    height: 21.0391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_313_899"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_313_899",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorIcon);
export default __webpack_public_path__ + "static/media/doorIcon.e1189ff06df638a12bc64c5133efc05a.svg";
export { ForwardRef as ReactComponent };